export default "__VITE_ASSET__BdkNQdl$__"